import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { ordersService, favoritesService, artworksService } from '../../services';

// Async thunks
export const fetchUserStats = createAsyncThunk(
  'stats/fetchUserStats',
  async (user_id, { rejectWithValue }) => {
    try {
      // Fetch purchases count
      const { data: orders, error: ordersError } = await ordersService.getUserOrders(user_id);
      if (ordersError) throw new Error(ordersError);

      // Fetch favorites count
      const { data: favorites, error: favoritesError } = await favoritesService.getUserFavorites(user_id);
      if (favoritesError) throw new Error(favoritesError);

      // Fetch user's artworks count
      const { data: artworks, error: artworksError } = await artworksService.getArtworks({ artist_id: user_id });
      if (artworksError) throw new Error(artworksError);

      return {
        purchases: orders?.length || 0,
        favorites: favorites?.length || 0,
        artworks: artworks?.length || 0
      };
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const initialState = {
  purchases: 0,
  favorites: 0,
  artworks: 0,
  loading: false,
  error: null
};

const statsSlice = createSlice({
  name: 'stats',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    resetStats: (state) => {
      state.purchases = 0;
      state.favorites = 0;
      state.artworks = 0;
      state.error = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchUserStats.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchUserStats.fulfilled, (state, action) => {
        state.loading = false;
        state.purchases = action.payload.purchases;
        state.favorites = action.payload.favorites;
        state.artworks = action.payload.artworks;
      })
      .addCase(fetchUserStats.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  }
});

export const { clearError, resetStats } = statsSlice.actions;
export default statsSlice.reducer;